import './SortTh.scss';
import Component from './SortTh.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
